import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';

export const Shed = () => (
    <>
        {/* Community Benefit Section */}
        <Container className='py-5 my-5 rounded shadow project-container'>
            <h3 className="project-heading text-center">Community Benefit</h3>
            <Row className='justify-content-center align-items-center'>
                <Col xs={12} md={12} className="d-flex flex-column justify-content-center mb-4 mb-4 mb-md-0">
                    <img src={`${process.env.PUBLIC_URL}/assets/shed/shed_mural.jpg`} alt='Garden Shed Mural 2024' />
                </Col>
                <Col xs={12} md={12} className="d-flex flex-column justify-content-center mb-4 pt-4">
                    <p>
                        We are bringing new life to St Nicholas Miracle Garden in Harlem with a shed rooftop pollinator garden and a powerful mural project. The initiative directly supports the <a href="https://www.uptowngoodfood.com/greenhouse" target="_blank" rel="noopener noreferrer">Uptown &amp; Boogie Healthy Project's</a> mission to improve green space, climate resilience, and community pride in Harlem and the Bronx.
                    </p>
                    <p>
                        We're working with a team of volunteers, architects Jixuan "Leslie" Li and Peggy Xiao, and civic engineers, who specializes in urban green infrastructure and pollinator habitats. The rooftop will feature native plants like sunflowers, purple coneflowers, and other pollinator-friendly species that support butterflies, bees, and birds. By cooling the area, reducing stormwater runoff, and offering a habitat for pollinators, this project fights the heat island effect and improves environmental health for everyone in the garden.
                    </p>
                </Col>
            </Row>
        </Container>

        {/* Project Goals Section */}
        <Container className='py-5 my-5 rounded shadow project-container'>
            <Row className='justify-content-center align-items-center'>
                <Col xs={12} md={5} className="d-flex flex-column justify-content-center mb-4 mb-4 mb-md-0">
                    <h3 className="project-heading">Project Goals</h3>
                </Col>
                <Col xs={12} md={7} className="d-flex flex-column justify-content-center mb-4">
                    <p className="project-text">
                        The goals for the shed include the following:
                    </p>
                    <ul>
                        <li>Organize shared equipment to support gardeners, volunteers, youth leaders, and market staff in their daily work.</li>
                        <li>Create a rooftop pollinator garden to enhance biodiversity, support local ecosystems, and provide educational opportunities about the importance of pollinators.</li>
                        <li>Activate the shed as a community landmark by integrating the bird mural project, using public art to celebrate local biodiversity and community creativity.</li>
                        <li>Improve the overall aesthetics of the garden area, making it a more inviting space for community members to gather and engage with nature.</li>
                        <li>Install a rooftop garden of native plants to provide habitat for birds and pollinators while modeling urban ecological stewardship.</li>
                    </ul>
                    <a href="https://uptowngoodfood.com/pages/garden-shed" target="_blank"
                        className="btn btn-warning btn-lg fs-2" rel="noopener noreferrer">Read More</a>

                </Col>
            </Row>
        </Container>

        <Container className='py-5 my-5 rounded shadow project-container'>
            <Row className='justify-content-center align-items-center'>
                <Col xs={12} md={5} className="d-flex flex-column justify-content-center mb-4 mb-4 mb-md-0">
                    <h3 className="project-heading">Press</h3>
                </Col>
                <Col xs={12} md={7} className="d-flex flex-column justify-content-center mb-4">
                    <h3>AUDUBON MAGAZINE</h3>
                    <h4>Audubon Mural Project in New York City's Community Gardens</h4>
                    <p>In this mural painted by artist Marthalicia Matarrita, Baltimore Orioles perch amid a cluster of native purple coneflowers and sunflowers. As part of the Audubon Mural Project—a public-art initiative drawing attention to birds that are vulnerable to extinction from climate change—NYC Parks’ Art in the Parks program and NYC Parks GreenThumb worked with the National Audubon Society, Gitler &_____ Gallery, and local artists to design murals in community gardens across the city.</p>
                    <a href="https://www.audubon.org/news/baltimore-oriole-marthalicia-matarrita" target="_blank"
                        className="btn btn-warning btn-lg fs-2" rel="noopener noreferrer">Read More</a>

                </Col>
            </Row>
        </Container>
    </>
);
